import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAccountId, selectApi, selectUserId, selectUserName, serializeError } from '@socialive/common';
import getIdFromSelfLink from '~/helpers/getIdFromSelfLink';
import { upsertAccountChannel } from '../slice';

export default createAsyncThunk(
  'channels/createChannel',
  async ({ name }, { dispatch, getState }) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    const userName = selectUserName(getState());
    const accountId = selectAccountId(getState());
    const userId = selectUserId(getState());

    const rawChannel = await api('/remoteStreams', {
      method: 'POST',
      data: {
        name,
        account: `/accounts/${accountId}`,
        user: `/users/${userId}`,
      },
    });

    const channel = {
      ...rawChannel,
      id: +getIdFromSelfLink(rawChannel),
      creatorName: userName,
    };

    await dispatch(upsertAccountChannel({ token: channel.token, data: channel }));

    return { channel };
  },
  { serializeError }
);
